import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Tilt from "react-parallax-tilt";
import myImg from "../../assets/avatar.svg";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="yellow"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I’ve fallen in love with programming ❤️ and enjoy building modern
              web and mobile products.
              <br />
              <br />
              Building cool stuff with{" "}
              <i>
                <b className="yellow">MERN, React Native and Next js </b>
              </i>{" "}
              . Scaling & Deploying it all with{" "}
              <i>
                <b className="yellow">AWS </b>
              </i>{" "}
              ☁️ for reliable, cloud-ready apps.
              <br />
              <br />
              Always
              <i>
                <b className="yellow"> curious</b>
              </i>{" "}
              , always building—turning ideas into{" "}
              <i>
                <b className="yellow"> products </b>
              </i>{" "}
              that matter 🚀
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={myImg}
                className="img-fluid blend-overlay"
                alt="avatar"
              />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
